import React from 'react';
import { Chip, useTheme, alpha } from '@mui/material';
import { ClientKind } from '../types';

const NAUTILUS = { deepOcean: '#0f2134', sand: '#ccba9b' };

type ContactKindChipProps = {
  kind?: ClientKind;
  size?: 'small' | 'medium';
};

export const ContactKindChip: React.FC<ContactKindChipProps> = ({ kind = 'client', size = 'small' }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const isClient = kind === 'client';
  const label = isClient ? 'Client' : 'Lead';

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        height: size === 'small' ? 20 : 24,
        borderRadius: 1,
        fontSize: '0.6rem',
        fontWeight: 700,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        bgcolor: isClient
          ? isDark
            ? alpha(NAUTILUS.sand, 0.18)
            : alpha(NAUTILUS.deepOcean, 0.08)
          : isDark
            ? alpha('#90caf9', 0.12)
            : alpha(NAUTILUS.deepOcean, 0.06),
        color: isClient
          ? isDark
            ? NAUTILUS.sand
            : NAUTILUS.deepOcean
          : isDark
            ? '#90caf9'
            : '#546e7a',
        border: `1px solid ${
          isClient
            ? isDark
              ? alpha(NAUTILUS.sand, 0.35)
              : alpha(NAUTILUS.deepOcean, 0.2)
            : isDark
              ? alpha('#90caf9', 0.25)
              : alpha(NAUTILUS.deepOcean, 0.15)
        }`,
      }}
    />
  );
};

type ContactBlacklistChipProps = {
  size?: 'small' | 'medium';
};

export const ContactBlacklistChip: React.FC<ContactBlacklistChipProps> = ({ size = 'small' }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const errorMain = theme.palette.error.main;

  return (
    <Chip
      label="Blacklisted"
      size={size}
      sx={{
        height: size === 'small' ? 20 : 24,
        borderRadius: 1,
        fontSize: '0.6rem',
        fontWeight: 700,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        bgcolor: isDark ? 'rgba(60, 20, 20, 0.3)' : alpha(errorMain, 0.08),
        color: isDark ? '#ff6363' : errorMain,
        border: `1px solid ${isDark ? 'rgba(255, 99, 99, 0.3)' : alpha(errorMain, 0.4)}`,
      }}
    />
  );
};

export default ContactKindChip;
